module.exports = __webpack_public_path__ + "static/media/v43.b274ea88.mp4";